export default "__VITE_ASSET__KRz1n_2l__"